<script>
	import { PUBLIC_PATH } from '$env/static/public';
</script>

<header class="z-100 w-full">
	<div class="bg-background-alt shadow-[0px_4px_4px_0px_rgba(197,197,197,0.25)]">
		<div
			class="mx-auto flex h-[3.75rem] lg:h-[5.707rem] max-w-[1366px] items-center justify-center lg:justify-between px-6 lg:px-12"
		>
			<a href={`${PUBLIC_PATH}/`} class="flex items-center gap-3">
				<img
					class="h-6 w-auto"
					src={`${PUBLIC_PATH}/images/ao_fincap_logo.svg`}
					alt="Angel Fincap Logo"
				/>
			</a>
			<nav class="hidden items-center gap-6 text-h6_light lg:flex">
				<a href={`${PUBLIC_PATH}/#home`} class="hover:text-primary">About Us</a>
				<a href={`${PUBLIC_PATH}/#products`} class="hover:text-primary">Products</a>
				<a href={`${PUBLIC_PATH}/#contact_us`} class="hover:text-primary">Contact Us</a>
			</nav>
		</div>
	</div>
</header>
